var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForeheadBg1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1438,
    height: 350,
    viewBox: "0 0 1438 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_206_2036",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1438,
    height: 350
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1438,
    height: 350,
    fill: "#E5F3F3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_206_2036)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 157.793,
    cy: 230.254,
    rx: 42.063,
    ry: 40.7742,
    transform: "rotate(-2.48788 157.793 230.254)",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1199.1,
    cy: 160.598,
    rx: 172.816,
    ry: 174.261,
    transform: "rotate(-2.48788 1199.1 160.598)",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1176.03 -12.8244L146.637 190.935L150.085 270.301L1190.66 323.901L1176.03 -12.8244Z",
    fill: "#FFF9E6"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.16 351.146L186.619 241.696L170.86 212.919L167.16 189.761L203.356 177.712L206.918 131.692H217.354V180.136L226.505 210.278L214.505 241.696L213.872 351.146H167.16Z",
    fill: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9277 351.318L83.3349 258.092L78.2007 233.688L118.888 195.572L139.286 207.562L132.164 210.134H117.602L104.327 233.688L123.795 253.383H132.164V259.814L107.314 265.383L109.698 351.318H61.9277Z",
    fill: "#FFE4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.795 212.271V253.384L204.438 248.675L200.689 202.418L123.795 212.271Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.764 210.45V194.395H166.094L174.572 208.254L147.764 210.45Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.169 246.419C172.506 246.419 181.696 238.961 181.696 229.76C181.696 220.56 172.506 213.102 161.169 213.102C149.833 213.102 140.643 220.56 140.643 229.76C140.643 238.961 149.833 246.419 161.169 246.419Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.169 243.847C168.949 243.847 175.256 237.541 175.256 229.761C175.256 221.981 168.949 215.674 161.169 215.674C153.389 215.674 147.082 221.981 147.082 229.761C147.082 237.541 153.389 243.847 161.169 243.847Z",
    fill: "#107393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.168 239.82C166.724 239.82 171.229 235.316 171.229 229.76C171.229 224.203 166.724 219.699 161.168 219.699C155.612 219.699 151.107 224.203 151.107 229.76C151.107 235.316 155.612 239.82 161.168 239.82Z",
    fill: "#D9E0A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.107 199.509L152.235 207.354H166.728L164.838 197.738L151.107 199.509Z",
    fill: "#D9E0A2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 244.58,
    height: 219.453,
    fill: "white",
    transform: "translate(-17 131.692)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeheadBg1);
export default __webpack_public_path__ + "static/media/forehead-bg1.ba5bc66196afea02409b2fefb26d9490.svg";
export { ForwardRef as ReactComponent };